import { ArtestGallery, ArtestGalleryBuilder } from "./artest-gallery";
export class ArtestCampaignGalleryBuilder extends ArtestGalleryBuilder {
    static compile(gallery, clear = false) {
        ArtestGalleryBuilder.compile(gallery, clear);
        ArtestCampaignGalleryBuilder.compileItemsStrip(gallery, clear);
        ArtestCampaignGalleryBuilder.compileControlButtons(gallery, clear);
        ArtestCampaignGalleryBuilder.applyItemsStripFunctionality(gallery);
        ArtestCampaignGalleryBuilder.applyControlButtonsFunctionality(gallery);
    }
    static compileItemsStrip(gallery, clear = false) {
        let container = gallery.elem;
        let strip_elem = clear ? null : container.querySelector(".artest-campaign-gallery-strip");
        if (strip_elem && strip_elem.parentNode != container)
            strip_elem = null;
        if (!strip_elem) {
            strip_elem = document.createElement("div");
            strip_elem.className = "artest-campaign-gallery-strip";
            container.appendChild(strip_elem);
        }
        let container_elem = clear ? null : container.querySelector(".artest-campaign-gallery-strip-container");
        if (!container_elem) {
            container_elem = document.createElement("div");
            container_elem.className = "artest-campaign-gallery-strip-container";
            strip_elem.appendChild(container_elem);
        }
        let items = container.querySelectorAll(".artest-campaign-gallery-strip-item");
        items.forEach((item, index) => {
            item.onclick = () => {
                gallery.goTo(index);
            };
        });
    }
    static applyItemsStripFunctionality(gallery) {
        const strip_elem = gallery.elem.querySelector(".artest-campaign-gallery-strip");
        const container_elem = strip_elem.querySelector(".artest-campaign-gallery-strip-container");
        const items = container_elem.querySelectorAll(".artest-campaign-gallery-strip-item");
        let item_left_offset_cache = {};
        gallery.elem.addEventListener(ArtestCampaignGallery.SLIDE_CHANGE_EVENT, (e) => {
            let { index } = e.detail;
            items.forEach((item, i) => {
                item.classList.remove('active');
            });
            let activeItem = items[index];
            if (!activeItem)
                return;
            activeItem.classList.add('active');
            if (!strip_elem || !container_elem)
                return;
            let itemLeft = item_left_offset_cache[index];
            if (itemLeft == null) {
                itemLeft = activeItem.getBoundingClientRect().left - container_elem.getBoundingClientRect().left;
                if (isNaN(itemLeft))
                    return;
                item_left_offset_cache[index] = itemLeft;
            }
            const item_width = activeItem.offsetWidth;
            const containerWidth = strip_elem.offsetWidth;
            const scrollLeft = itemLeft - (containerWidth / 2) + (item_width / 2);
            strip_elem.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
            });
        });
    }
    static compileControlButtons(gallery, clear = false) {
        if (!gallery.options.controls)
            return;
        let wrapper = gallery.elem;
        let container = wrapper.querySelector(".artest-campaign-gallery");
        let prev_btn = clear ? null : wrapper.querySelector(".artest-campaign-gallery > .prev-btn.btn-wrap");
        if (prev_btn && prev_btn.parentNode != container)
            prev_btn = null;
        if (!prev_btn) {
            prev_btn = document.createElement("a");
            prev_btn.className = "prev-btn btn-wrap";
            prev_btn.href = "javascript:void(0)";
            container.appendChild(prev_btn);
        }
        let next_btn = clear ? null : wrapper.querySelector(".artest-campaign-gallery > .next-btn.btn-wrap");
        if (next_btn && next_btn.parentNode != container)
            next_btn = null;
        if (!next_btn) {
            next_btn = document.createElement("a");
            next_btn.className = "next-btn btn-wrap";
            next_btn.href = "javascript:void(0)";
            container.appendChild(next_btn);
        }
        gallery.DOM.prev_btn = prev_btn;
        gallery.DOM.next_btn = next_btn;
    }
    static applyControlButtonsFunctionality(gallery) {
        if (!gallery.options.controls)
            return;
        let wrapper = gallery.elem;
        const prev_btn = wrapper.querySelector(".artest-campaign-gallery > .prev-btn.btn-wrap");
        const next_btn = wrapper.querySelector(".artest-campaign-gallery > .next-btn.btn-wrap");
        if (!prev_btn || !next_btn)
            return;
        prev_btn.onclick = () => {
            gallery.goToPrev();
        };
        next_btn.onclick = () => {
            gallery.goToNext();
        };
    }
}
export class ArtestCampaignGallery extends ArtestGallery {
    constructor(elem, options, oeuvres, artists) {
        const initializedOptions = Object.assign(Object.assign({}, options), { timeout: options.timeout == null ? 10000 : parseInt(String(options.timeout)), controls: options.controls == null ? true : !!options.controls, height: options.height == null ? null : parseInt(String(options.height)), lazy_loading: options.lazy_loading == null ? true : !!options.lazy_loading, ratio: 1 });
        super(elem, initializedOptions, oeuvres, artists);
        this.$$latest_i = 0;
        this.$$timeouter = null;
        if (!this.DOM)
            this.DOM = {};
        if (!this.DOM.oeuvres) {
            this.DOM.oeuvres = null;
            this.build(true);
        }
        this.length = this.DOM.oeuvres.children.length;
        if (this.options.height && this.options.height > 0) {
            this.options.ratio = this.options.height / 100;
        }
        if (this.options.ratio !== 1) {
            let ratio_str = `${parseInt(String(100 * this.options.ratio))}%`;
            for (let i = 0; i < this.length; i++) {
                this.DOM.oeuvres.children[i].$img.style.paddingTop = ratio_str;
            }
        }
        this.goTo(0);
        this.run();
    }
    compileDOM(clear = false) {
        ArtestCampaignGalleryBuilder.compile(this, clear);
    }
    run() {
        clearTimeout(this.$$timeouter);
        if (this.options.timeout > 0) {
            this.$$timeouter = setTimeout(() => {
                this.goToNext();
                this.run();
            }, this.options.timeout);
        }
        else {
            this.$$timeouter = null;
        }
    }
    stop() {
        clearTimeout(this.$$timeouter);
    }
    goTo(i) {
        const refreshContainerHeight = (elem, ratio) => {
            if (typeof ratio === "number") {
                let height_str = "";
                if (ratio < this.options.ratio) {
                    height_str = `${parseInt(String(100 * ratio))}%`;
                    elem.$img.style.paddingTop = height_str;
                }
            }
        };
        const addClass = (e, c) => {
            const cls = e.className.split(" ");
            cls.push(c);
            e.className = cls.join(" ");
        };
        const rmClass = (e, c) => {
            const cls = e.className.split(" ");
            const idx = cls.indexOf(c);
            if (idx >= 0) {
                cls.splice(idx, 1);
            }
            e.className = cls.join(" ");
        };
        i = isNaN(i) ? 0 : (((i % this.length) + this.length) % this.length);
        const prev_i = i > 0 ? i - 1 : this.length - 1;
        const next_i = i < this.length - 1 ? i + 1 : 0;
        for (let n = 0; n < this.DOM.oeuvres.children.length; n++) {
            const e = this.DOM.oeuvres.children[n];
            rmClass(e, "prev");
            rmClass(e, "next");
            rmClass(e, "current");
            if (n === prev_i) {
                addClass(e, "prev");
            }
            else if (n === next_i) {
                addClass(e, "next");
                e.runLazyLoad && setTimeout(e.runLazyLoad);
            }
            else if (n === i) {
                addClass(e, "current");
                e.runLazyLoad && setTimeout(e.runLazyLoad);
            }
        }
        this.$$latest_i = i;
        try {
            const elem = this.DOM.oeuvres.children[i];
            if (elem) {
                let ratio = elem.dataset.ratio && parseInt(elem.dataset.ratio) || null;
                if (ratio != null) {
                    refreshContainerHeight(elem, ratio);
                }
                else if (elem.dataset.thumb_img_url) {
                    const img = new Image();
                    img.onload = () => {
                        ratio = img.naturalHeight / img.naturalWidth;
                        elem.dataset.ratio = `${ratio}`;
                        refreshContainerHeight(elem, ratio);
                    };
                    img.src = elem.dataset.thumb_img_url;
                }
                else {
                    refreshContainerHeight(elem);
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        this.elem.dispatchEvent(new CustomEvent(ArtestCampaignGallery.SLIDE_CHANGE_EVENT, { detail: { index: i } }));
    }
    goToNext() {
        this.goTo((this.$$latest_i || 0) + 1);
    }
    goToPrev() {
        this.goTo((this.$$latest_i || 0) - 1);
    }
    static Inject(elem, options, data) {
        elem.gallery = new ArtestCampaignGallery(elem, options, data.oeuvres, data.artists);
    }
}
ArtestCampaignGallery.SLIDE_CHANGE_EVENT = "slide-change";
